import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Settings, TrendingUp, Database, Users, CheckCircle, Star } from 'lucide-react';

const ERPPage = () => {
  const features = [
    'Gestão integrada de stock e inventário',
    'Controlo financeiro completo',
    'Gestão de recursos humanos',
    'Automação de processos operacionais',
    'Relatórios gerenciais avançados',
    'Integração com sistemas externos'
  ];

  const benefits = [
    { icon: TrendingUp, title: 'Eficiência Operacional', desc: 'Reduza custos operacionais em até 25%' },
    { icon: Database, title: 'Dados Centralizados', desc: 'Informações unificadas em tempo real' },
    { icon: Users, title: 'Gestão de Equipas', desc: 'Ferramentas para RH e performance' },
    { icon: Settings, title: 'Customização Total', desc: 'Adapte o sistema às suas necessidades' }
  ];

  return (
    <>
      <Header />
      <main className="min-h-screen bg-gray-50">
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-purple-600 to-purple-800 text-white py-20 pt-32">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Unisales-ERP</h1>
              <p className="text-xl mb-8 text-purple-100">
                Integre todos os processos do seu negócio numa plataforma unificada.
                Controlo total sobre operações, finanças e recursos humanos.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button className="bg-white text-purple-700 px-8 py-3 rounded-full font-semibold hover:bg-purple-50 transition duration-300">
                  Agendar Demonstração
                </button>
                <Link to="/contact" className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-purple-700 transition duration-300">
                  Fale Conosco
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* Overview Section */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-3xl font-bold mb-6">ERP Empresarial Completo</h2>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    O Unisales-ERP é a solução ideal para empresas que procuram integrar todos os departamentos
                    numa única plataforma. Com módulos personalizáveis e interface moderna, terá
                    controlo total sobre todas as operações do seu negócio.
                  </p>
                  <ul className="space-y-3">
                    {features.map((feature, index) => (
                      <li key={index} className="flex items-center">
                        <CheckCircle className="w-5 h-5 text-purple-500 mr-3 flex-shrink-0" />
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                  <div className="text-center">
                    <Settings className="w-16 h-16 text-purple-600 mx-auto mb-4" />
                    <h3 className="text-2xl font-bold mb-4">Integração Total</h3>
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center">
                        <div className="text-3xl font-bold text-purple-600">100%</div>
                        <p className="text-sm text-gray-600">Integração de módulos</p>
                      </div>
                      <div className="text-center">
                        <div className="text-3xl font-bold text-purple-600">24/7</div>
                        <p className="text-sm text-gray-600">Suporte contínuo</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">Benefícios Principais</h2>
              <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                Otimize a sua empresa com a nossa solução ERP
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => {
                const IconComponent = benefit.icon;
                return (
                  <div key={index} className="text-center p-6 rounded-xl hover:shadow-lg transition duration-300">
                    <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <IconComponent className="w-8 h-8 text-purple-600" />
                    </div>
                    <h3 className="text-xl font-semibold mb-3">{benefit.title}</h3>
                    <p className="text-gray-600">{benefit.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        {/* <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold mb-4">O que os nossos clientes dizem</h2>
            </div>
            <div className="max-w-4xl mx-auto">
              <div className="bg-white p-8 rounded-2xl shadow-lg">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <blockquote className="text-lg text-gray-700 mb-4">
                  "O Unisales-ERP unificou todos os nossos processos. Agora temos visibilidade completa
                  de todas as operações e conseguimos tomar decisões mais rápidas e informadas."
                </blockquote>
                <cite className="text-gray-600 font-semibold">
                  Carlos Oliveira, CEO - Industrial Ltda
                </cite>
              </div>
            </div>
          </div>
        </section> */}

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">Pronto para integrar o seu negócio?</h2>
            <p className="text-xl mb-8 text-purple-100">
              Descubra como o nosso ERP pode otimizar as suas operações.
            </p>
            <button className="bg-white text-purple-700 px-8 py-3 rounded-full font-semibold hover:bg-purple-50 transition duration-300">
              Agendar Demonstração Gratuita
            </button>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ERPPage;
